import React from "react";

const DynamicCircle = ({ cx = 150, cy = 150, value, color, selectedBet, disabled,isPotrait }) => {
    return (
        <div style={{ position: 'relative' }}>
            <button className="hover-target" style={{  width: isPotrait ? "150px" : "100px", height: isPotrait?"150px":"100px", borderRadius: "50%", position: "absolute", zIndex: "1", cursor: "pointer" }} disabled={disabled} onClick={selectedBet}></button>
            <div
                className="rotate-target"
                style={{ position: 'relative', zIndex: '0' }}
            >
                <svg
                    width={isPotrait?150:100}
                    height={isPotrait?150:100}
                    viewBox="0 0 300 300"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Background */}
                    <circle cx={cx} cy={cy} r="135" fill="#fff" />

                    {/* Rotating Group */}
                    <g className="rotating-part">
                        {/* Outer segmented ring */}
                        <circle
                            cx={cx}
                            cy={cy}
                            r="135"
                            fill="none"
                            stroke={color}
                            strokeWidth="2"
                        />

                        {/* Middle segmented ring */}
                        <circle
                            cx={cx}
                            cy={cy}
                            r="125"
                            fill="none"
                            stroke={color}
                            strokeWidth="20"
                            strokeDasharray="40 90"
                        />

                        {/* Inner solid ring */}
                        <circle
                            cx={cx}
                            cy={cy}
                            r="110"
                            fill="none"
                            stroke={color}
                            strokeWidth="15"
                        />
                    </g>

                    {/* Center circle */}
                    <circle
                        cx={cx}
                        cy={cy}
                        r="85"
                        fill="#fff"
                        stroke={color}
                        strokeWidth="3"
                    />

                    {/* Center Text (Not Rotating) */}
                    <text
                        x={cx-5}
                        y={cy}
                        textAnchor="middle"
                        dominantBaseline="central"
                        fill="#000"
                        fontWeight="bold"
                        fontSize={
                            value
                                ? value.toString().length === 5
                                    ? 50
                                    : value.toString().length === 4
                                        ? 60
                                        : 80
                                : 60
                        }
                    >
                        {value}
                    </text>
                </svg>
            </div>

        </div>
    );
};

export default DynamicCircle;
